// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"8e7b2421","420":"0a671e8a","780":"7aa1f1e8","830":"0eb35352","981":"ac47b77b"}[chunkId] + ".chunk.css";
};